import { useContext } from "react";
import GlobalStatusContext from "../context/GlobalStatusProvider";

const useGlobalStatus = () => {
  return useContext(GlobalStatusContext);
}

export default useGlobalStatus;